export default __webpack_public_path__ + "static/media/icon.563f14f1.svg";